module.exports = __webpack_public_path__ + "img/lovecosmetic2_banner.d7bf4d56.png";